import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_bypassing_the_approval_workflow'),
    description: defineMessage('what_is_to_happen_if_ap_workflow_in_approvalmax'),
    warning: defineMessage('please_select_cin_core__t_to_enable_this_option'),
    doNotPullDocumentLabel: defineMessage('do_not_pull_this_document_to_approvalmax'),
    pullDocumentLabel: defineMessage('pull_this_document_to_approvalmax'),
    pullDocumentDescription: defineMessage('select_from_which_date__x_and_put_under_control'),
    datePlaceholder: defineMessage('pick_a_date'),
    notifyCheckboxText: defineMessage('notify_the_organisation_he_approvalmax_workflow'),
};
